import React from "react";

import CellArrayItemWithTooltip from "../../../../ui/Table/CellArrayItemWithTooltip";

import { Checkbox } from "react-bootstrap";

import { Rating } from "react-simple-star-rating";

import data from "./data";

const handleRowSelected = (actions, dispatch, row, status) => {
  actions.updateCoachPoolSelectedCoach(dispatch, row.id, status);
};

const columns = (actions, dispatch, state, stateFilter) => [
  {
    name: (
      <Checkbox
        checked={state.allRecordSelected}
        onChange={(e) => {
          const recordIds = data(state, stateFilter).map((coach) => coach.id);
          actions.selectAllFilteredRecords(
            dispatch,
            e.target.checked,
            recordIds
          );
        }}
      />
    ),
    sortable: false,
    width: "50px",
    cell: (row) => (
      <Checkbox
        onChange={(e) =>
          handleRowSelected(actions, dispatch, row, e.target.checked)
        }
        checked={state.coachSelected.includes(row.id.toString())}
      />
    ),
  },
  {
    name: "Coach Name",
    selector: "attributes.full_name",
    sortable: true,
    width: "280px",
  },
  {
    name: "Email",
    selector: "attributes.email",
    sortable: true,
    width: "200px",
  },
  {
    name: "Rating",
    sortable: true,
    selector: "attributes.ratings",
    cell: (row) => (
      <>
        <Rating
          initialValue={row.attributes.ratings}
          readonly={true}
          allowFraction={true}
          size="20"
          SVGstrokeColor="#F9C35A"
          fillColor="#F9C35A"
        />
        <span style={{ paddingBottom: "2px", paddingLeft: "5px" }}>
          {row.attributes.ratings_text}
        </span>
      </>
    ),
    width: "170px",
  },
  {
    name: "Language",
    sortable: false,
    cell: (row) => <CellArrayItemWithTooltip arr={row.attributes.languages} />,
    width: "150px",
  },
  {
    name: "Career Level",
    sortable: false,
    cell: (row) => (
      <CellArrayItemWithTooltip arr={row.attributes.career_levels} />
    ),
    width: "150px",
  },
  {
    name: "On Pause",
    selector: "attributes.pause",
    sortable: true,
    width: "100px",
  },
];

export default columns;
